var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.953 1.008 4.986 3.89v12.14l3.986-2.794 4.041 2.785V3.886zm3.061 13.109-3.045-2.1-2.982 2.091V4.399l2.975-2.161 3.053 2.165v9.714zm-4.76-8.116c0 .965.785 1.75 1.75 1.75s1.75-.785 1.75-1.75-.785-1.75-1.75-1.75-1.75.785-1.75 1.75m1.75-.75c.413 0 .75.337.75.75s-.337.75-.75.75-.75-.337-.75-.75.337-.75.75-.75"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tag.svg";